import { makeAutoObservable } from "mobx";

// ─── Drawer-стор: состояние дровера и навигация по шагам ─────────────────────

export class LegalDrawerStore {
  isDrawerOpen = false;
  currentStep = 0;
  legalTypeSelected: "legal" | "selfemployed" | null = null;
  /** Шаги, данные которых уже сохранены на бэкенде */
  completedSteps: Set<number> = new Set();
  /** Максимальный шаг, до которого пользователь уже доходил */
  reachedStep = 0;
  /** Предупреждение о несохранённых данных при переходе на другой шаг */
  unsavedWarning: { show: boolean; targetStep: number } = {
    show: false,
    targetStep: 0,
  };

  constructor() {
    makeAutoObservable(this);
  }

  markStepCompleted = (step: number) => {
    this.completedSteps.add(step);
  };

  setInitialCompletedSteps = (steps: number[]) => {
    this.completedSteps = new Set(steps);
  };

  advanceTo = (step: number) => {
    this.currentStep = step;
    if (step > this.reachedStep) this.reachedStep = step;
  };

  showUnsavedWarning = (targetStep: number) => {
    this.unsavedWarning = { show: true, targetStep };
  };

  dismissUnsavedWarning = () => {
    this.unsavedWarning = { show: false, targetStep: 0 };
  };

  reset = () => {
    this.isDrawerOpen = false;
    this.currentStep = 0;
    this.reachedStep = 0;
    this.legalTypeSelected = null;
    this.completedSteps = new Set();
    this.unsavedWarning = { show: false, targetStep: 0 };
  };
}
